// src/components/SceneSelector.tsx
import React from 'react';

interface SceneSelectorProps {
    scenes: { name: string; label: string }[];
    current: string;
    onSelect: (scene: string) => void;
}

const SceneSelector: React.FC<SceneSelectorProps> = ({ scenes, current, onSelect }) => {
    return (
        <div className="menu">
            {scenes.map((scene) => (
                <button
                    key={scene.name}
                    className={current === scene.name ? 'active' : ''}
                    onClick={() => onSelect(scene.name)}
                >
                    {scene.label}
                </button>
            ))}
        </div>
    );
};

export default SceneSelector;